import type { ChangeEvent } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AppInput } from "../../../../shared/components/AppInput";
import { ModalBasic } from "../../../../shared/components/ModalBasic";
import { StorageObjectValue } from "../../../../services/api/instances/storageApi/types/service_types";
import { StorageObjectVersion } from "../../../../services/api/instances/storageApi/types/object_types";
import styles from "./styles.module.css";

interface Props<T extends StorageObjectValue> {
  selectedVersion: StorageObjectVersion<T>;
  createVersion: (name: string) => void;
  closeModal: () => void;
  modalType: string;
}

export const SaveVersionModal = <T extends StorageObjectValue>(
  props: Props<T>,
) => {
  const [versionName, setVersionName] = useState<string>("");
  const { t } = useTranslation();

  const handleVersionNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    setVersionName(event.target.value);
  };
  return (
    <ModalBasic
      open={props.modalType === "save"}
      title={t("versioning.save_modal_title")}
      hasCloseButton
      onClose={props.closeModal}
      closeModal={props.closeModal}
      hasFooter
      buttonOkText={t("versioning.save_modal_ok_button")}
      onOk={() => {
        props.createVersion(versionName as string);
        setVersionName("");
        props.closeModal();
      }}
      onCancel={props.closeModal}
      className={styles["modal"]}
    >
      <div className={styles.container}>
        <AppInput
          value={versionName}
          onChange={handleVersionNameChange}
          placeholder={t("versioning.save_modal_placeholder")}
          className={styles.input}
        />
      </div>
    </ModalBasic>
  );
};
